const es = {
    nav: {
        home: 'Inicio',
        aboutUs: 'Sobre Nosotros',
        services: 'Servicios',
        pages: 'Páginas',
        pricing: 'Precios',
        team: 'Equipo',
        faq: 'FAQ',
        blog: 'Blog',
        blogList: 'Lista de Blog',
        blogDetail: 'Detalle del Blog',
        contactUs: 'Contacto',
        login: 'Iniciar Sesión',
    },

    footer: {
        callNow: 'Llámenos Ahora',
        aboutUsTitle: 'Sobre Nosotros',
        aboutUsText: 'Pure Key Homes es su socio de confianza en gestión de propiedades y servicios para invitados. Nos dedicamos a proporcionar tranquilidad, comodidad y atención profesional para los propietarios y sus invitados.',
        contactUsNow: 'Contáctenos Ahora',
        ourLinks: 'Nuestros enlaces',
        ourServices: 'Nuestros Servicios',
        propertyManagement: 'Gestión de Propiedades',
        keyHolding: 'Custodia de Llaves',
        meetAndGreet: 'Recepción de Invitados',
        cleaningService: 'Servicio de Limpieza',
        laundryService: 'Servicio de Lavandería',
        propertyCheck: 'Revisión de Propiedad',
        contactUsTitle: 'Contacto',
        privacyPolicy: 'Política de Privacidad',
        termsOfService: 'Términos de Servicio',
        legal: 'Legal',
        copyright: 'Derechos de Autor © {{year}} Pure Key Homes. Todos los derechos reservados.',
    },

    home: {
        bannerTitle: 'Su Gestión de Propiedades en Costa Cálida y Costa Blanca Sur.',
        bannerPlaceholder: 'Email o número de teléfono...',
        bannerButton: 'Quiero ser contactado',
        servicesSubtitle: 'SERVICIOS',
        servicesTitle: 'Lo Que Ofrecemos',
        testimonialSubtitle: 'TESTIMONIO',
        testimonialTitle: 'Lo Que Dicen Nuestros Clientes',
        faqSubtitle: 'FAQ',
        faqTitle: 'Preguntas Comunes Sobre Gestión de Propiedades',
    },

    features: {
        subtitle: 'CARACTERÍSTICAS',
        title: 'Detrás de la Historia',
        description: 'Somos un equipo de gestión de propiedades en Costa Cálida y Costa Blanca, ofreciendo servicios personalizados, fiables y transparentes para proteger su inversión y garantizar una excelente experiencia para sus invitados.',
        fullPropertyManagement: 'Gestión Completa de la Propiedad',
        fullPropertyManagementDesc: 'Servicio de recepción de invitados, comunicación continua con los invitados y gestión completa de la propiedad entre reservas.',
        cleaningAndLaundry: 'Servicio de Limpieza y Lavandería',
        cleaningAndLaundryDesc: 'Limpieza profesional y lavandería entre estancias',
        guestCommunication: 'Comunicación con Invitados 24/7',
        guestCommunicationDesc: 'Comunicación con los invitados antes, durante y después de la estancia',
        readMore: 'Leer Más',
    },

    aboutBlog: {
        subtitle: 'SOBRE NOSOTROS',
        title: 'Gestionamos Su Propiedad',
        description: 'Desde la llegada del invitado hasta su salida, nos encargamos de todo — en persona, in situ y con total transparencia. Para que disfrute de su propiedad sin preocupaciones.',
        reservationManagement: 'Gestionamos sus reservas de principio a fin',
        keyHolding247: 'Custodia segura de llaves, disponible 24/7',
        cleaningService: 'Limpieza profesional entre cada estancia',
        laundryService: 'Ropa de cama y toallas siempre listas',
        propertyCheckAlarm: 'Revisiones de propiedad y respuesta a alarmas 24/7',
        readMore: 'Leer Más',
    },

    withUs: {
        subtitle: 'Comuníquese con Nosotros',
        title: '¿Quiere gestionar su propiedad con confianza? Contáctenos hoy y hablemos sobre cómo podemos ayudarle.',
        contactUsNow: 'Contáctenos Ahora',
    },

    servicesList: {
        propertyManagement: 'Gestión de Propiedades',
        propertyManagementDesc: 'Gestionamos su propiedad con comunicación con invitados, check-in/out, limpieza, mantenimiento y custodia de llaves, asegurando que su inversión esté protegida',
        meetAndGreet: 'Recepción de Invitados',
        meetAndGreetDesc: 'Recibimos personalmente a sus invitados, les mostramos la propiedad y les proporcionamos toda la información necesaria para una estancia cómoda.',
        cleaningService: 'Servicio de Limpieza',
        cleaningServiceDesc: 'Proporcionamos limpieza profesional entre las estancias de los invitados, asegurando que su propiedad esté impecable, higienizada y lista.',
        laundryService: 'Servicio de Lavandería',
        laundryServiceDesc: 'Nuestro servicio de lavandería asegura que todas las sábanas y toallas estén frescas, limpias y perfectamente preparadas para cada invitado.',
        keyHolding: 'Custodia de Llaves',
        keyHoldingDesc: 'Servicios de gestión y entrega de llaves segura para garantizar un check-in y check-out sin problemas para cada invitado.',
        mortgage: 'Hipoteca',
        mortgageDesc: 'Financiación para una nueva inversión en propiedad.',
        support247: 'Soporte 24x7',
        support247Desc: 'De día o de noche, estamos aquí para gestionar su propiedad y responder rápidamente a cualquier situación.',
        webDevelopment: 'Desarrollo Web',
        webDevelopmentDesc: 'Con nuestro servicio de Gestión Completa de la Propiedad, le ofrecemos un sitio web completamente personalizado para su propiedad.',
        exploreAllServices: 'Ver Todos los Servicios',
    },

    priceList: {
        subtitle: 'PLAN DE PRECIOS',
        title: 'Elija Su Plan',
        startingFrom: 'Precios desde solo €15/mes — planes flexibles adaptados a las necesidades de su propiedad.',
        getStarted: 'Comenzar',
        mostPopular: 'Más Popular',
        keyHolding: 'Custodia de Llaves',
        keyHoldingDesc: 'Almacenamiento seguro de llaves y gestión de acceso',
        keyHoldingFeatures: ['Almacenamiento seguro de llaves', 'Disponibilidad 24/7', 'Coordinación de acceso a la propiedad', 'Check-in/out de invitados', 'Acceso de emergencia'],
        propertyManagement: 'Gestión de Propiedades',
        propertyManagementDesc: 'Atención completa de la propiedad',
        propertyManagementFeatures: ['Inspecciones de la propiedad', 'Coordinación de mantenimiento', 'Respuesta a emergencias', 'Informes mensuales', 'Pagos de facturas'],
        cleaningService: 'Servicio de Limpieza',
        cleaningServiceDesc: 'Limpieza profesional de la propiedad',
        cleaningServiceFeatures: ['Limpieza profunda', 'Limpieza post-alquiler', 'Mantenimiento regular', 'Productos ecológicos', 'Servicio de ropa disponible'],
        laundryService: 'Servicio de Lavandería',
        laundryServiceDesc: 'Lavandería profesional y cuidado de la ropa',
        laundryServiceFeatures: ['Lavar y doblar', 'Cambio de ropa de cama', 'Servicio de plancha', 'Entrega rápida', 'Entrega incluida'],
    },

    touchStart: {
        subtitle: 'CONTACTO',
        title: 'Gestionamos su propiedad con facilidad',
        panelSub: 'Estamos aquí para ayudarle en cada paso del camino.',
        panelPhone: 'Teléfono',
        panelEmail: 'Correo electrónico',
        panelLocation: 'Ubicación',
        panelLocationValue: 'Los Alcazares, Murcia, España',
        panelHours: 'Horario',
        panelHoursValue: 'Lun – Dom: 24h/7',
        firstName: 'Nombre',
        lastName: 'Apellido',
        emailAddress: 'Dirección de Correo Electrónico',
        phoneNumber: 'Número de Teléfono',
        selectCountryCode: 'Seleccione código de país...',
        message: 'Mensaje...',
        submitNow: 'Enviar Ahora',
        submitting: 'Enviando...',
        formSuccess: '¡Éxito!',
        formSuccessText: '¡Gracias por contactarnos! Le responderemos en un plazo de 24 horas.',
        errorInvalidEmail: 'Por favor, introduzca una dirección de correo electrónico válida (ej., nombre@ejemplo.com)',
        errorInvalidPhone: 'Por favor, introduzca un número de teléfono válido (6-15 dígitos)',
        errorRequiredField: 'Este campo es obligatorio',
        errorValidationTitle: 'Por Favor Revise Su Información',
        errorValidationMessage: 'Por favor, corrija los errores resaltados e inténtelo de nuevo.',
        errorTitle: 'No Se Pudo Enviar el Mensaje',
        errorMessage: 'No pudimos enviar su mensaje. Por favor, inténtelo de nuevo o contáctenos directamente por teléfono o correo electrónico.',
    },

    ourBlog: {
        subtitle: 'NUESTRO BLOG',
        title: 'Últimas Noticias',
        viewAllNews: 'Ver Todas las Noticias',
    },

    aboutUsPage: {
        parentPage: 'Inicio',
        activePage: 'Empresa',
        motherMenu: 'Sobre Nosotros',
        testimonialSubtitle: 'TESTIMONIO',
        testimonialTitle: 'Lo Que Dicen Nuestros Clientes',
    },

    aboutUsContent: {
        subtitle: 'SOBRE NOSOTROS',
        title: 'Su Socio de Confianza en Gestión de Propiedades',
        description1: 'Pure Key Homes es una empresa profesional de gestión de propiedades basada en Costa Cálida y Costa Blanca, España. Nos especializamos en proporcionar servicios completos de cuidado de propiedades para los propietarios, ya sea que vivan en el extranjero o simplemente quieran estar tranquilos sabiendo que su propiedad está en manos expertas.',
        description2: 'Con años de experiencia en gestión de propiedades, entendemos los desafíos únicos de mantener una propiedad en España. Nuestro equipo multilingüe habla inglés, español y portugués, asegurando una comunicación sin problemas con los propietarios de todo el mundo.',
        whyChoose: '¿Por Qué Nos Elegir?',
        professionalService: 'Servicio Profesional',
        professionalServiceDesc: 'Equipo experimentado dedicado a mantener su propiedad según los más altos estándares',
        availability247: 'Disponibilidad 24/7',
        availability247Desc: 'Apoyo las 24 horas para emergencias y coordinación de acceso a la propiedad',
        multilingualTeam: 'Equipo Multilingüe',
        multilingualTeamDesc: 'Fluidos en inglés, español, francés y portugués para una comunicación sin problemas',
        localExpertise: 'Conocimiento Local',
        localExpertiseDesc: 'Profundo conocimiento de la gestión de propiedades en Costa Cálida y Costa Blanca',
        ourMission: 'Nuestra Misión',
        ourMissionDesc: 'Proporcionar servicios excepcionales de gestión de propiedades que den a los propietarios una tranquilidad completa, asegurando que sus propiedades se mantengan, sean seguras y estén listas cuando las necesiten.',
        ourVision: 'Nuestra Visión',
        ourVisionDesc: 'Ser la empresa de gestión de propiedades más confiable y fiable en la región, conocida por su profesionalismo, transparencia y dedicación a la satisfacción del cliente.',
    },

    counter: {
        guestsHosted: 'Invitados Atendidos',
        reservationsManaged: 'Reservas Gestionadas',
        propertiesManaged: 'Propiedades Gestionadas',
        yearsOfExperience: 'Años de Experiencia',
        starRating: 'Calificación',
    },

    story: {
        subtitle: 'NUESTRA HISTORIA',
        title: 'La Historia de Pure Key Homes',
        theIdea: 'La Idea',
        theIdeaDesc: 'Ana era la directora de un hotel de cinco estrellas en Lisboa, Portugal, y Pedro era un desarrollador de software. Durante una vacaciones en La Manga, rápidamente se enamoraron de la calidad de vida y el potencial de la región. Lo que empezó como unas vacaciones pronto se convirtió en una visión para el futuro.',
        businessConception: 'Concepción del Negocio',
        businessConceptionDesc: 'Combinando la experiencia de Ana en hotelería con el conocimiento tecnológico de Pedro, comenzaron a dar forma a un concepto profesional de gestión de propiedades. Esta colaboración marcó el nacimiento oficial de Pure Key Homes.',
        legalSetup: 'Configuración Legal y Operativa',
        legalSetupDesc: 'El enfoque se desplazó al cumplimiento legal, los procesos operativos y los estándares de servicio, asegurando que cada propiedad se gestionaría de manera transparente, segura y profesional.',
        growth: 'Crecimiento e Infraestructura',
        growthDesc: 'Con una base sólida en su lugar, Pure Key Homes expandió su infraestructura, tecnología y red de servicios, ofreciendo una gestión fiable de propiedades desde La Manga hasta Torre de la Horadada.',
    },

    serviceArea: {
        subtitle: 'ÁREA DE SERVICIO',
        title: 'Operamos en toda la Costa Blanca Sur y Costa Cálida',
        specialCoverage: 'Con cobertura especial en:',
    },

    teamSection: {
        subtitle: 'NUESTRO EQUIPO',
        title: 'Conozca a Nuestro Equipo',
        ana: 'Ana',
        anaSub: 'CEO',
        pedro: 'Pedro',
        pedroSub: 'Gerente y Desarrollador',
        marco: 'Marco',
        marcoSub: 'Colaborador Clave',
    },

    servicesPage: {
        parentPage: 'Inicio',
        activePage: 'Nuestros Servicios',
        motherMenu: 'Servicios',
        testimonialSubtitle: 'TESTIMONIO',
        testimonialTitle: 'Lo Que Dicen Nuestros Clientes',
        close: 'Cerrar',
        propertyManagement: 'Gestión de Propiedades',
        propertyManagementShort: 'Soluciones completas de cuidado y mantenimiento de su propiedad',
        propertyManagementDetail: 'Nuestro servicio completo de gestión de propiedades asegura que su propiedad se mantenga según los más altos estándares. Nos encargamos de todos los aspectos del cuidado de la propiedad, incluyendo mantenimiento regular, reparaciones, coordinación con proveedores y respuesta a emergencias. Ya sea que viva en el extranjero o simplemente quiera estar tranquilo, nuestro equipo experimentado trata su propiedad como si fuera la propia, proporcionando informes y actualizaciones detalladas sobre todas las actividades.',
        keyHolding: 'Custodia de Llaves',
        keyHoldingShort: 'Almacenamiento seguro de llaves y gestión de acceso a la propiedad',
        keyHoldingDetail: 'Proporcionamos servicios seguros de custodia de llaves, asegurando el acceso autorizado a su propiedad cuando sea necesario. Nuestro equipo profesional mantiene protocolos de seguridad estrictos y registros de acceso detallados. Coordinamos con contratistas, limpiadores y proveedores de servicios, eliminando la necesidad de que usted esté presente. Todas las llaves se almacenan en una instalación segura y vigilada con cobertura de seguro completa.',
        meetAndGreet: 'Recepción de Invitados',
        meetAndGreetShort: 'Servicio profesional de bienvenida para sus invitados y visitantes',
        meetAndGreetDetail: 'Cause una excelente primera impresión con nuestro servicio personalizado de recepción. Recibimos a sus invitados, les proporcionamos orientación sobre la propiedad, les entregan las llaves y nos aseguramos de que tengan todo lo necesario para una estancia cómoda. Nuestro equipo multilingüe puede comunicarse en inglés, español y portugués, haciendo que sus invitados se sientan como en casa desde el momento en que llegan.',
        cleaningService: 'Servicio de Limpieza',
        cleaningServiceShort: 'Servicios profesionales de limpieza para su propiedad',
        cleaningServiceDetail: 'Nuestro servicio de limpieza minucioso asegura que su propiedad esté impecable y acogedora. Ofrecemos horarios de limpieza regular, limpieza profunda y limpieza de cambio entre invitados. Nuestro experimentado equipo de limpieza utiliza productos de alta calidad y sigue listas de verificación detalladas para asegurarse de que cada rincón sea atendido.',
        laundryService: 'Servicio de Lavandería',
        laundryServiceShort: 'Servicios completos de lavandería y cuidado de la ropa',
        laundryServiceDetail: 'Proporcionamos servicios completos de lavandería incluyendo lavado, secado, plancha y preparación de ropa de cama fresca. Nuestro servicio asegura que su propiedad siempre tenga ropa de cama y toallas frescas y limpias listas para los invitados o su próxima visita.',
        propertyCheck: 'Revisión de Propiedad',
        propertyCheckShort: 'Inspecciones y monitoreo regular de la propiedad',
        propertyCheckDetail: 'Nuestro servicio de revisión de propiedad incluye inspecciones regulares para identificar y resolver posibles problemas antes de que se conviertan en problemas. Verificamos fugas de agua, problemas eléctricos, preocupaciones de seguridad y necesidades de mantenimiento general. Cada visita incluye un informe detallado con fotos.',
        alarmResponse: 'Respuesta a Alarmas',
        alarmResponseShort: 'Servicio de respuesta a alarmas de emergencia 24/7',
        alarmResponseDetail: 'Nuestro servicio de respuesta a alarmas proporciona acción inmediata cuando se activa la alarma de su propiedad. Disponible 24/7, nuestro equipo asistirá a su propiedad, se relacionará con las empresas de seguridad y los servicios de emergencia, y tomará las medidas apropiadas para asegurar su propiedad.',
        registerGuests: 'Registro de Invitados',
        registerGuestsShort: 'Asistencia en el registro y check-in de invitados',
        registerGuestsDetail: 'Nos encargamos de todos los aspectos del registro de invitados, incluyendo los procedimientos oficiales de check-in, documentación y notificación a las autoridades locales según lo requerido por la ley española.',
        upholsteryCleaning: 'Limpieza de Tapicería',
        upholderyCleaningShort: 'Limpieza profunda de muebles y tapicería',
        upholsteryCleaningDetail: 'Nuestro servicio especializado de limpieza de tapicería revitaliza sus muebles, eliminando manchas, olores y alérgenos. Utilizamos equipos y técnicas profesionales adecuadas para diferentes telas y materiales.',
        mortgageServices: 'Servicios de Hipoteca',
        mortgageServicesShort: 'Asistencia con hipotecas y servicios financieros españoles',
        mortgageServicesDetail: 'Navegue por el mercado de hipotecas españolas con nuestra orientación experta. Le conectamos con asesores financieros y corredores de hipotecas de confianza que entienden los requisitos únicos para los propietarios extranjeros.',
        support247: 'Soporte 24x7',
        support247Short: 'Disponibilidad las 24 horas para todas sus necesidades',
        support247Detail: 'Nuestro compromiso con usted no se detiene fuera de las horas de oficina. Proporcionamos soporte 24/7 para emergencias, solicitudes urgentes y tranquilidad. Ya sea una emergencia de mantenimiento, un problema con un invitado o simplemente una pregunta, nuestro equipo siempre está disponible para ayudarle.',
    },

    pricingPage: {
        parentPage: 'Inicio',
        activePage: 'Nuestros Precios',
        motherMenu: 'Precios',
        testimonialSubtitle: 'TESTIMONIO',
        testimonialTitle: 'Lo Que Dicen Nuestros Clientes',
    },

    teamPage: {
        parentPage: 'Inicio',
        activePage: 'Nuestro Equipo',
        motherMenu: 'Equipo',
        testimonialSubtitle: 'TESTIMONIO',
        testimonialTitle: 'Lo Que Dicen Nuestros Clientes',
    },

    faqPage: {
        parentPage: 'Inicio',
        activePage: 'FAQ',
        motherMenu: 'FAQ',
        subtitle: 'FAQ',
        title: 'Preguntas Frecuentes',
        faq2Subtitle: 'FAQ',
        faq2Title: 'Guía de Gestión de Propiedades',
        faq2Desc: 'Todo lo que necesita saber sobre la gestión de su propiedad con Pure Key Homes.',
        categoryGeneral: 'Gestión General de Propiedades',
        categoryServices: 'Servicios a Huéspedes & Gestión',
        categoryPricing: 'Comenzar & Precios',
        testimonialSubtitle: 'TESTIMONIO',
        testimonialTitle: 'Lo Que Dicen Nuestros Clientes',

        q1: '¿En qué áreas operan?',
        a1: 'Operamos en Costa Cálida y Costa Blanca, con cobertura especial en Los Alcázares, Torre Pacheco, San Javier, Santiago de la Ribera, La Manga, Pilar de la Horadada y Torre de la Horadada.',

        q2: '¿Qué servicios se incluyen en la gestión completa de la propiedad?',
        a2: 'Nuestra gestión completa incluye comunicación con los huéspedes antes, durante y después de su estancia, servicio de recepción, custodia de llaves, limpieza profesional y lavandería entre estancias, revisiones de la propiedad, coordinación de mantenimiento, soporte de emergencia 24/7 e informes detallados.',

        q3: '¿Cómo manejan las emergencias?',
        a3: 'Proporcionamos servicio de respuesta a emergencias 24/7. Nuestro equipo in situ puede atender su propiedad inmediatamente ante situaciones urgentes como fugas de agua, problemas eléctricos o cuestiones de seguridad. Coordinamos con servicios de emergencia y contratistas locales según sea necesario y le mantenemos informado.',

        q4: '¿Puedo personalizar los servicios que necesito?',
        a4: '¡Absolutamente! Ofrecemos paquetes de servicios flexibles. Ya sea que necesite solo custodia de llaves, limpieza entre huéspedes o gestión completa de la propiedad, podemos adaptar nuestros servicios a sus requisitos y presupuesto específicos.',

        q5: '¿Con qué frecuencia inspeccionan mi propiedad?',
        a5: 'Para propiedades de alquiler, inspeccionamos antes y después de cada estancia de huéspedes. Para propiedades no alquiladas, podemos programar revisiones regulares semanalmente, quincenalmente o mensualmente según su preferencia. Cada inspección incluye un informe detallado con fotos.',

        q6: '¿Ustedes se encargan del check-in y check-out de los huéspedes?',
        a6: '¡Sí! Proporcionamos un servicio personal de recepción, damos la bienvenida a los huéspedes a su llegada, les mostramos la propiedad, explicamos cómo funciona todo y estamos disponibles durante toda su estancia. También nos encargamos de las inspecciones de check-out y recogida de llaves.',

        q7: '¿Qué idiomas habla su equipo?',
        a7: 'Nuestro equipo multilingüe habla inglés, español, portugués y francés, garantizando una comunicación fluida con propietarios y huéspedes de todo el mundo.',

        q8: '¿Ustedes gestionan reservas de plataformas como Airbnb y Booking.com?',
        a8: 'Sí, podemos gestionar sus anuncios en todas las principales plataformas incluyendo Airbnb, Booking.com y Vrbo. Manejamos la comunicación con huéspedes, sincronización de calendarios, optimización de precios y garantizamos el cumplimiento de todos los requisitos de las plataformas.',

        q9: '¿Qué incluye su servicio de limpieza?',
        a9: 'Nuestra limpieza profesional incluye limpieza completa de todas las habitaciones, electrodomésticos de cocina, baños, suelos, superficies, limpieza de ventanas y eliminación de basura. También proporcionamos ropa de cama y toallas limpias, y garantizamos que la propiedad esté lista para huéspedes con todas las comodidades.',

        q10: '¿Con qué rapidez pueden organizar mantenimiento o reparaciones?',
        a10: 'Trabajamos con contratistas locales de confianza y normalmente podemos organizar reparaciones urgentes en 24 horas. Para mantenimiento no urgente, coordinamos con usted primero y proporcionamos presupuestos antes de proceder. Todo el trabajo es supervisado y documentado.',

        q11: '¿Cómo puedo comenzar?',
        a11: 'Simplemente contáctenos por teléfono, correo electrónico o el formulario de contacto de nuestro sitio web. Programaremos una reunión para discutir sus necesidades, visitar su propiedad y crear un plan de servicios personalizado. Normalmente podemos incorporar nuevas propiedades en 48 horas.',

        q12: '¿Hay un contrato o compromiso mínimo?',
        a12: 'Ofrecemos acuerdos flexibles según sus necesidades. Para gestión completa de propiedades, normalmente trabajamos con acuerdos trimestrales. Para servicios individuales como limpieza o custodia de llaves, no se requiere compromiso a largo plazo.',

        q13: '¿Cómo recibiré informes sobre mi propiedad?',
        a13: 'Recibirá informes detallados por correo electrónico después de cada revisión de la propiedad, estancia de huéspedes o visita de mantenimiento. Los informes incluyen fotos, notas sobre la condición de la propiedad, cualquier problema encontrado y acciones tomadas. También puede solicitar actualizaciones en cualquier momento.',

        q14: '¿Cuáles son sus tarifas de servicio?',
        a14: 'Nuestros precios dependen de los servicios que necesite y del tamaño de su propiedad. Ofrecemos tarifas transparentes y competitivas sin cargos ocultos. Contáctenos para un presupuesto personalizado basado en sus requisitos específicos.',

        q15: '¿Están asegurados y licenciados?',
        a15: 'Sí, estamos totalmente asegurados y operamos en cumplimiento con todas las regulaciones españolas de gestión de propiedades. Mantenemos seguro de responsabilidad profesional y trabajamos con contratistas licenciados para todos los servicios especializados.',
    },

    blogListPage: {
        parentPage: 'Inicio',
        activePage: 'Nuestro Blog',
        motherMenu: 'Blog',
    },

    blogDetailPage: {
        parentPage: 'Inicio',
        activePage: 'Detalle del Blog',
        motherMenu: 'Blog',
        relatedBlog: 'Blog Relacionado',
        relatedBlogSubtitle: 'NUESTRO BLOG',
        postReview: 'REVISIÓN',
        comments: 'Comentarios',
        reply: 'Responder',
        replyNow: 'RESPONDER AHORA',
        leaveAReply: 'Deje una Respuesta',
        firstName: 'Nombre',
        lastName: 'Apellido',
        emailAddress: 'Dirección de Correo Electrónico',
        message: 'Mensaje',
        postNow: 'Publicar Ahora',
        tag: 'Etiqueta:',
        formSuccess: '¡Bien hecho!',
        formSuccessText: 'formulario enviado exitosamente',
    },

    contactPage: {
        parentPage: 'Inicio',
        activePage: 'Contacto',
        motherMenu: 'Contacto',
        callNow: 'Llame Ahora',
        location: 'Ubicación',
        emailAddress: 'Dirección de Correo Electrónico',
    },

    blogSidebar: {
        search: 'Buscar',
        searchPlaceholder: 'Buscar...',
        recentPost: 'Publicaciones Recientes',
        category: 'Categoría',
        advertising: 'Publicidad',
        tags: 'Etiquetas',
        gallery: 'Galería',
    },

    blogCard: {
        readMore: 'LEER MÁS',
    },

    loginPage: {
        backToSite: 'Volver al Sitio',
        welcomeBack: 'Bienvenido de Nuevo',
        signInToAccount: 'Inicie sesión en su cuenta',
        continueWithGoogle: 'Continuar con Google',
        continueWithMicrosoft: 'Continuar con Microsoft',
        or: 'O',
        loginWithEmail: 'Iniciar Sesión con Email y Contraseña',
        emailAddress: 'Dirección de Correo Electrónico',
        password: 'Contraseña',
        forgotPassword: '¿Olvidó su contraseña?',
        signIn: 'Iniciar Sesión',
        signingIn: 'Iniciando Sesión...',
    },
};

export default es;
